<template>
  <div style="padding: 20px 15px">
    <div style="text-align: center; margin-bottom: 20px">
      <h3>用户协议</h3>
      <p>版本生效日期：2025年10月29日</p>
      <p>发布主体：无锡风睐科技有限公司（以下简称“本公司”“我们”或“合意I”）</p>
    </div>
    <h4 style="margin-top: 20px">第一条 协议的确认与接受</h4>
    <p>
      1.
      本《合意I用户协议》（以下简称“本协议”）由您（以下简称“用户”）与无锡风睐科技有限公司就您下载、安装、注册、登录、使用“合意I”应用程序（以下简称“本应用”或“合意I”）所订立。
    </p>
    <p>
      2.
      请您在使用本应用前，务必认真阅读并充分理解本协议的全部内容，特别是涉及免除或限制责任的条款、管辖与争议解决条款等。
    </p>
    <p>
      若您不同意本协议任一内容，请立即停止使用本应用。您一旦注册或使用本应用，即视为您已阅读并同意受本协议全部条款约束。
    </p>
    <h4 style="margin-top: 20px">第二条 服务内容与功能说明</h4>
    <p>
      1.
      “合意I”是一款关系约定工具，旨在为双方提供“关系确认”、“意愿记录”、“电子存证”等服务，帮助双方自愿、理性地达成约定并形成电子协议。
    </p>
    <p>2. 主要功能包括：</p>
    <p>(1)手机号注册登录；</p>
    <p>(2)使用系统预设模版生成电子协议；</p>
    <p>(3)通过二维码方式邀请对方查看、确认并签署；</p>
    <p>(4)双方可进行活体检测以增强协议的真实性；</p>
    <p>(5)用户可选择付费进行电子存证；</p>
    <p>(6)在符合法律程序的情况下，用户可申请导出协议用于司法辅助。</p>
    <p>
      3.
      本应用仅作为关系记录与意愿确认工具，并不直接参与、干预或保证任何用户间的现实关系、行为结果及法律效力。
    </p>
    <h4 style="margin-top: 20px">第三条 用户资格与账户管理</h4>
    <p>
      1.
      用户注册时应使用本人真实有效的手机号，并确保提供的信息真实、准确、完整。
    </p>
    <p>
      2.
      用户有义务妥善保管账号及登录凭证，不得转让、出租或出借。如因用户自身原因造成账户泄露、被盗，本公司不承担相关责任。
    </p>
    <p>3. 若发现任何未经授权的使用行为，应立即通知本公司。</p>
    <h4 style="margin-top: 20px">第四条 协议生成与签署规则</h4>
    <p>1. 用户可在应用内选择系统提供的模版生成协议，协议内容由双方自主确认。</p>
    <p>
      2.
      双方确认后即视为形成电子协议。若任一方拒绝或未完成签署，则协议视为未成立。
    </p>
    <p>
      3.
      平台仅提供技术服务，不对用户间协议内容的合法性、真实性及履行结果承担任何担保责任。
    </p>
    <p>
      4.
      用户不得利用本应用制作、传播违反法律法规或社会公序良俗的内容（包括但不限于涉黄、涉暴、侮辱、诽谤、隐私侵犯等）。
    </p>
    <h4 style="margin-top: 20px">第五条 活体检测与定位信息</h4>
    <p>
      1.
      活体检测用于验证签署者身份的真实性，采集的信息包括面部特征数据、实时视频帧等，仅用于确认签署行为的真实性。
    </p>
    <p>2. 定位功能用于记录协议签署的地点信息，仅在用户授权的情况下启用。</p>
    <p>3. 上述信息均受《隐私政策》保护，不会用于除验证、存证之外的其他目的。</p>
    <h4 style="margin-top: 20px">第六条 电子存证与司法导出</h4>
    <p>
      1. 本应用提供电子存证服务，存证文件由第三方存证机构完成存证并出具证明。
    </p>
    <p>
      2.
      存证服务仅证明电子数据在特定时间的存在性与完整性，不代表对协议内容合法性的实质审查。
    </p>
    <p>
      3.
      用户如需将存证材料用于司法程序，应通过合法途径向平台提出书面申请，经身份验证与授权确认后，由本公司依法协助导出。
    </p>
    <h4 style="margin-top: 20px">第七条 用户行为规范</h4>
    <p>
      1.
      用户在使用本应用时应遵守中国大陆相关法律法规，不得利用本应用从事以下行为：
    </p>
    <p>(1)制作、传播淫秽、色情、赌博、暴力、恐怖、政治敏感内容；</p>
    <p>(2)侵犯他人隐私、名誉权、肖像权、知识产权；</p>
    <p>(3)冒充他人、虚假签署、伪造身份；</p>
    <p>(4)以任何形式干扰、破坏平台正常运营。</p>
    <p>
      2.
      若用户违反前述规定，本公司有权暂停或终止其账户，并保留向有关部门报告及追究法律责任的权利。
    </p>
    <h4 style="margin-top: 20px">第八条 知识产权</h4>
    <p>
      1.
      本应用的全部内容，包括但不限于文字、图形、界面设计、程序代码、商标、Logo等，均属于无锡风睐科技有限公司所有。
    </p>
    <p>2. 未经书面许可，任何人不得复制、传播、修改、反向工程或用于商业用途。</p>
    <h4 style="margin-top: 20px">第九条 免责声明</h4>
    <p>
      1.
      本应用仅提供技术平台，不参与用户之间的实际关系或行为。任何由用户自愿行为引发的法律后果，均由用户自行承担。
    </p>
    <p>2. 本公司不对以下情况承担责任：</p>
    <p>(1)因用户提供虚假信息导致协议无效；</p>
    <p>(2)因网络故障、系统维护、不可抗力导致的服务中断；</p>
    <p>(3)因用户违法行为或侵权行为造成的损失。</p>
    <p>
      3.
      对于任何因用户违反法律法规、违反本协议条款而引起的第三方索赔、处罚或损害，用户应当独立承担全部责任。
    </p>
    <h4 style="margin-top: 20px">第十条 服务变更、中止与终止</h4>
    <p>1. 本公司有权根据运营需要随时调整服务内容或终止部分功能。</p>
    <p>
      2.
      用户有权随时注销账户，注销后本公司将按照《隐私政策》删除或匿名化处理相关信息。
    </p>
    <p>3. 如用户存在违法违规行为，本公司有权立即停止服务。</p>
    <h4 style="margin-top: 20px">第十一条 争议解决与法律适用</h4>
    <p>1. 本协议签订地为中华人民共和国江苏省无锡市梁溪区。</p>
    <p>2. 本协议的订立、执行与解释均适用中华人民共和国大陆地区法律。</p>
    <p>
      3.
      因本协议产生的争议，双方应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。
    </p>
    <h4 style="margin-top: 20px">第十二条 其他</h4>
    <p>
      1.
      本公司有权根据法律变化和运营需要随时修改本协议，修改内容将在应用内公布。
    </p>
    <p>2. 用户继续使用本应用即视为接受修改后的协议内容。</p>
  </div>
</template>
<script setup></script>
<style lang="scss" scoped>
p {
  font-size: 14px;
}
</style>
